import { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Navbar from "../../components/navbar";
import apiClient from "../../utils/apiClient";
import { useNavigate } from "react-router-dom";
import WorkshopQuestions from "../../components/Counselling/InitialInfo/WorkshopQuestions";

// --------------------
// Styled components (unchanged)
// --------------------
const DashboardWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  minHeight: "100vh",
  backgroundColor: "#f8fafc",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    left: 0,
    top: 0,
    backgroundImage: `url("/image 7.png")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    backgroundColor: "#f8fafc",
    opacity: 1,
    zIndex: 0,
    pointerEvents: "none",
  },
}));
const ContentContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  maxWidth: "1200px",
  margin: "0 auto",
  padding: theme.spacing(3),
  [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
  zIndex: 1,
}));

// --------------------
// MAIN COMPONENT
// --------------------
const InitialInfo = () => {
  const [workshopDone, setWorkshopDone] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responses, setResponses] = useState({
    q1: { range: "", domains: [] },
    q2: { range: "", domains: [] },
    q3: { domains: [] },
    q4: { domains: [] },
    q5: { decided: "", domains: [] },
  });
  const navigate = useNavigate();

  const isWorkshopFormValid = () => {
    if (workshopDone !== true) return true;

    // Q1
    if (!responses.q1.range || responses.q1.domains.length === 0) return false;

    // Q2
    if (!responses.q2.range || responses.q2.domains.length === 0) return false;

    // Q3
    if (responses.q3.domains.length === 0) return false;

    // Q4
    if (responses.q4.domains.length === 0) return false;

    // Q5
    if (!responses.q5.decided) return false;
    if (responses.q5.decided === "Yes" && responses.q5.domains.length === 0)
      return false;

    return true;
  };

  const handleNextClick = async () => {
    // if (!selected) return;
    setIsSubmitting(true);
    const response = await apiClient.patch(
      "/counselling/initial-info/workshop",
      { workshopDone, workshopResponses: workshopDone ? responses : null },
    );
    if (response.data.success) {
      navigate("/past-info");
    } else {
      alert("Some error occured!");
    }
    setIsSubmitting(false);
  };

  const handleBack = async () => {
    navigate("/areaType-info");
  };

  // const [hasBoughtCounselling, setHasBoughtCounselling] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  // useEffect(() => {
  //   const checkBuyStatus = async () => {
  //     try {
  //       const response = await apiClient.get("/counselling/buyStatus");
  //       console.log(response);
  //       if (response?.data?.success) {
  //         if (response.data.boughtStatus) {
  //           navigate("/stream-info");
  //         }
  //       }
  //     } catch (error) {
  //       console.error("Failed to check counselling buy status:", error);
  //     } finally {
  //       setCheckingStatus(false);
  //     }
  //   };

  //   checkBuyStatus();
  // }, []);

  return (
    <DashboardWrapper>
      <Navbar />
      <ContentContainer>
        {!isSubmitting && (
          <Box backgroundColor="white" px={3} py={2} borderRadius={8}>
            <Typography
              fontSize={24}
              fontWeight={600}
              mb={2}
              textAlign={"center"}
            >
              Have you done YAPASSIO’s career decision workshop?
            </Typography>

            <Box display="flex" justifyContent="center" gap={2}>
              <Button
                variant={workshopDone === true ? "contained" : "outlined"}
                onClick={() => {
                  setWorkshopDone(true);
                  setCurrentQuestion(1);
                }}
              >
                Yes
              </Button>

              <Button
                variant={workshopDone === false ? "contained" : "outlined"}
                onClick={() => {
                  setWorkshopDone(false);
                  setCurrentQuestion(0);
                }}
              >
                No
              </Button>
            </Box>
          </Box>
        )}
        {!isSubmitting && workshopDone === true && (
          <Box mt={4} backgroundColor="white" p={3} borderRadius={8}>
            <WorkshopQuestions
              responses={responses}
              setResponses={setResponses}
              currentQuestion={currentQuestion}
              setCurrentQuestion={setCurrentQuestion}
            />
          </Box>
        )}
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{
                mt: 4,
                backgroundColor: "#fff",
                borderRadius: "100px",
                textTransform: "none",
                fontWeight: 600,
                "&:hover": { backgroundColor: "#2799AD" },
                width: "200px",
                p: 1,
                fontSize: "20px",
              }}
            >
              Back
            </Button>
          </div>
          {!isSubmitting && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                disabled={
                  workshopDone == null ||
                  (workshopDone === true && !isWorkshopFormValid())
                }
                onClick={handleNextClick}
                sx={{
                  mt: 4,
                  backgroundColor: "#30B0C7",
                  borderRadius: "100px",
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": { backgroundColor: "#2799AD" },
                  width: "200px",
                  p: 1,
                  fontSize: "20px",
                }}
              >
                Next
              </Button>
            </div>
          )}
        </div>
        {isSubmitting && (
          <Typography
            fontSize={40}
            my={20}
            fontWeight={500}
            textAlign={"center"}
            fontFamily={"Aclonica"}
          >
            Submitting the details...
          </Typography>
        )}
      </ContentContainer>
    </DashboardWrapper>
  );
};

export default InitialInfo;
